<template>
  <div>
    <!-- Attesa -->
    <v-progress-circular
      :size="50"
      indeterminate
      color="primary"
      v-if="attesa"
      style="display: flex; margin: 0 auto"
    ></v-progress-circular>

    <!-- Dettaglio -->
    <v-expansion-panel flat class="has-border-bottom" v-model="panelRiferimento">
      <v-expansion-panel-content
        v-for="(item,j) in testataOrdine"
        :key="j"
        @click.native="caricaDatiDettaglio(item.cdArticoloPadre, j)"
      >
        <template v-slot:header>
          <div
            v-html="$functions.getCodArticoloFormat(item.cdArticoloPadre) + ' ' + $functions.convertiTestoGrassetto(item.descrizioneProdotto)"
          >{{}}</div>
        </template>

        <!-- Lista articoli -->
        <articoli
          :itemsArticoli="dettaglioOrdine"
          @aggiornaDati="aggiornaStatoEvasione"
          :codeBar="codeBarArticolo"
          :panelRiferimento="parseInt(panelRiferimento)"
          :tipoEvasione="'prelievoManiglie'"
          v-if="panelRiferimento===j"
        ></articoli>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { get_maniglie } from "@/api/api.js";
import Articoli from "@/components/articoli/Articoli.vue";

export default {
  components: {
    Articoli
  },

  data() {
    return {
      panelTestata: 0,
      panelRiferimento: null,
      panelRifSel: -1,

      testataOrdine: {},

      codeBarOrdine: "",
      codeBarArticolo: {},

      dettaglioOrdine: [],

      readOnlyCodeBar: false,

      attesa: false,
      attesaPeso: false,

      peso: 0,
      carrello: ""
    };
  },

  methods: {
    caricaDati() {
      // Reset
      this.resetDati();

      this.attesa = true;
      this.readOnlyCodeBar = true;

      get_maniglie("")
        .then(res => {
          // Testata
          this.testataOrdine = res.data;

          // Memorizzo il documento letto
          this.$store.commit(
            "app/setDocumentoLetto",
            this.testataOrdine.nrDocu
          );

          this.panelTestata = 1;
        })
        .catch(err => {
          console.log(err);
          this.$toast.warning(this.$functions.getErrorMsg(err));
        })
        .finally(() => {
          this.attesa = false;
          this.readOnlyCodeBar = false;
        });
    },

    caricaDatiDettaglio(cdArticolo, panelRifIndex) {
      this.datiDettaglio = [];

      // -----------------
      // Gestione pannello
      if (this.panelRiferimento == null) {
        // Reset
        //this.datiDettaglio = [];
        this.panelRifSel = -1;

        return;
      }
      if (this.panelRiferimento !== panelRifIndex) return;
      if (this.panelRifSel == this.panelRiferimento) return;
      this.panelRifSel = this.panelRiferimento;
      // -----------------

      get_maniglie(cdArticolo)
        .then(res => {
          this.dettaglioOrdine = res.data;
        })
        .catch(err => {
          console.log(err);
          this.$toast.warning(this.$functions.getErrorMsg(err));
        })
        .finally(() => {
          this.attesa = false;
          this.readOnlyCodeBar = false;
        });
    },

    resetDati() {
      // Reset
      this.testataOrdine = {};
      this.dettaglioOrdine = [];
      this.panelRiferimento = null;
      this.peso = 0;
      this.carrello = "";
    },

    cercaOrdine() {
      if (Object.keys(this.testataOrdine) == 0) {
        let ultimoNumero = this.$store.getters["app/getUltimoDocumentoLetto"];

        if (ultimoNumero) {
          this.codeBarOrdine = ultimoNumero;
        } else return;
      } else {
        this.codeBarOrdine = this.testataOrdine.nrDocuStampato;
      }

      this.caricaDati();
    },

    aggiornaStatoEvasione(row, idUnivoco) {
      // Ricavo la riga
      let r = this.dettaglioOrdine.find(f => f.idUnivoco == idUnivoco);

      // Viene attivata la computed getDettaglio
      r.statoEvasione = row.statoEvasione;
      r.qtEvasaStoccata = row.qtEvasaStoccata;
      r.qtRimanenza = row.qtRimanenza;
      r.parziale = row.parziale;
      r.qtaScaffale = row.qtaScaffale;
      r.qtaDaStoccare = row.qtaDaStoccare;
    }
  },

  mounted() {
    this.caricaDati();
  },

  computed: {
    getCodebar() {
      return this.$store.getters["app/getCodebar"];
    },

    getTipo() {
      return this.$store.getters["app/getTipo"].toLowerCase() == "evaso"
        ? 1
        : 0;
    },

    getDettaglio() {
      return this.dettaglioOrdine.filter(f => f.statoEvasione == this.getTipo);
    },

    getRiferimenti() {
      return this.$functions.groupByIndex(this.getDettaglio, "nrRiferimento");
    }
  },

  watch: {
    getCodebar(v) {
      // Controllo tipo ricerca
      if (this.panelRiferimento != null) {
        // --- Ricerca x articolo ---

        // NOTA: passo un json con la data x forzare la watch anche se ripasso lo stesso valore
        this.codeBarArticolo = v;
      }
    },

    panelRiferimento() {
      //console.log("watch panelRiferimento")

      // NOTA: quando cambia pannello, resetto l'articolo selezionato
      this.$store.commit("app/resetArticoloSelezionato");
    },

    getTipo(v) {
      // NOTA: quando passo da daEvadere\evasi chiudi eventuali panel aperti
      this.panelRiferimento = null;
    }
  }
};
</script>

